/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Drop_Files_Artifacts_Disabled_SubtitleInputs */



/**
* | output |
* | --- |
* | "Uploading files to the artifact folder is not allowed." |
*
* @param {Spaces_Drop_Files_Artifacts_Disabled_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_drop_files_artifacts_disabled_subtitle = /** @type {((inputs?: Spaces_Drop_Files_Artifacts_Disabled_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Drop_Files_Artifacts_Disabled_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Hochladen von Dateien in den Artefakt-Ordner ist nicht möglich.")
	return /** @type {LocalizedString} */ ("Uploading files to the artifact folder is not allowed.")
});